import React from "react";
import './index.css'
import { useDispatch, useSelector } from "react-redux";
import MessageBox from "../../Components/MessageBox";
import LoadingBox from "../../Components/Loader";
import { listOrderMine } from "../../store/actions/orderAction";
import { useEffect } from "react";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
function OrderHistoryScreen(props) {
  const orderMineList = useSelector((state) => state.orderMineList);
  const navigate = useNavigate();
  const { orders, loading, error } = orderMineList;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(listOrderMine());
  }, [dispatch]);
  return (
    <div>
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <>
          <div className="imageOverlayContainerOrder">
            <h1>Order History</h1>
            <div className="colorOverlayOrder"></div>
          </div>

          <div className="container center-screen text-center">
            <div className="myDataTable">
              <Table responsive="sm" hover>
                <thead>
                  <tr className="tr">
                    <th>Order Id</th>
                    <th>Date</th>
                    <th>Total</th>
                    <th>paid</th>
                    <th>Delivered</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => {
                    return (
                      <tr key={order._id}>
                        <td>{order._id}</td>
                        <td>{order.createdAt.substring(0, 10)}</td>
                        <td>{`${order.totalPrice}$`}</td>
                        <td>
                          {order.ispaid ? order.paidAt.substring(0, 10) : "No"}
                        </td>
                        <td>
                          {order.isdelivered
                            ? order.deliveredAt.substring(0, 10)
                            : "No"}
                        </td>
                        <td className="detailfield">
                          <Button
                            onClick={() =>
                              navigate(`/order/${order._id}`)
                            }
                            className="w-100 text-center"
                            variant="primary"
                          >
                            Details
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default OrderHistoryScreen;
